/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BusinessSectorWithOrigin } from './';
import {
    BusinessSectorWithOriginFromJSON,
    BusinessSectorWithOriginFromJSONTyped,
    BusinessSectorWithOriginToJSON,
} from './';
import type { CategoryWithOrigin } from './';
import {
    CategoryWithOriginFromJSON,
    CategoryWithOriginFromJSONTyped,
    CategoryWithOriginToJSON,
} from './';
import type { ExperienceWithOrigin } from './';
import {
    ExperienceWithOriginFromJSON,
    ExperienceWithOriginFromJSONTyped,
    ExperienceWithOriginToJSON,
} from './';
import type { FormerCompanyWithOrigin } from './';
import {
    FormerCompanyWithOriginFromJSON,
    FormerCompanyWithOriginFromJSONTyped,
    FormerCompanyWithOriginToJSON,
} from './';
import type { JobTitleWithOrigin } from './';
import {
    JobTitleWithOriginFromJSON,
    JobTitleWithOriginFromJSONTyped,
    JobTitleWithOriginToJSON,
} from './';
import type { KeywordWithOrigin } from './';
import {
    KeywordWithOriginFromJSON,
    KeywordWithOriginFromJSONTyped,
    KeywordWithOriginToJSON,
} from './';
import type { NewDailyRateWithOrigin } from './';
import {
    NewDailyRateWithOriginFromJSON,
    NewDailyRateWithOriginFromJSONTyped,
    NewDailyRateWithOriginToJSON,
} from './';
import type { RefinementCriteriaWithOrigin } from './';
import {
    RefinementCriteriaWithOriginFromJSON,
    RefinementCriteriaWithOriginFromJSONTyped,
    RefinementCriteriaWithOriginToJSON,
} from './';
import type { WorkConditionsWithOrigin } from './';
import {
    WorkConditionsWithOriginFromJSON,
    WorkConditionsWithOriginFromJSONTyped,
    WorkConditionsWithOriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface MatchingCriteriaResponse
 */
export interface MatchingCriteriaResponse {
    /**
     * 
     * @type {JobTitleWithOrigin}
     * @memberof MatchingCriteriaResponse
     */
    jobTitle: JobTitleWithOrigin;
    /**
     * 
     * @type {CategoryWithOrigin}
     * @memberof MatchingCriteriaResponse
     */
    category?: CategoryWithOrigin;
    /**
     * 
     * @type {CategoryWithOrigin}
     * @memberof MatchingCriteriaResponse
     */
    initialCategory: CategoryWithOrigin;
    /**
     * 
     * @type {Array<ExperienceWithOrigin>}
     * @memberof MatchingCriteriaResponse
     */
    experiences: Array<ExperienceWithOrigin>;
    /**
     * 
     * @type {NewDailyRateWithOrigin}
     * @memberof MatchingCriteriaResponse
     */
    dailyRate: NewDailyRateWithOrigin;
    /**
     * 
     * @type {WorkConditionsWithOrigin}
     * @memberof MatchingCriteriaResponse
     */
    workConditions?: WorkConditionsWithOrigin;
    /**
     * 
     * @type {Array<FormerCompanyWithOrigin>}
     * @memberof MatchingCriteriaResponse
     */
    formerCompanies?: Array<FormerCompanyWithOrigin>;
    /**
     * 
     * @type {BusinessSectorWithOrigin}
     * @memberof MatchingCriteriaResponse
     */
    businessSector?: BusinessSectorWithOrigin;
    /**
     * 
     * @type {Array<KeywordWithOrigin>}
     * @memberof MatchingCriteriaResponse
     */
    keywords?: Array<KeywordWithOrigin>;
    /**
     * 
     * @type {Array<RefinementCriteriaWithOrigin>}
     * @memberof MatchingCriteriaResponse
     */
    refinements?: Array<RefinementCriteriaWithOrigin>;
}

/**
 * Check if a given object implements the MatchingCriteriaResponse interface.
 */
export function instanceOfMatchingCriteriaResponse(value: object): value is MatchingCriteriaResponse {
    if (!('jobTitle' in value) || value['jobTitle'] === undefined) return false;
    if (!('initialCategory' in value) || value['initialCategory'] === undefined) return false;
    if (!('experiences' in value) || value['experiences'] === undefined) return false;
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    return true;
}

export function MatchingCriteriaResponseFromJSON(json: any): MatchingCriteriaResponse {
    return MatchingCriteriaResponseFromJSONTyped(json, false);
}

export function MatchingCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchingCriteriaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'jobTitle': JobTitleWithOriginFromJSON(json['jobTitle']),
        'category': json['category'] == null ? undefined : CategoryWithOriginFromJSON(json['category']),
        'initialCategory': CategoryWithOriginFromJSON(json['initialCategory']),
        'experiences': ((json['experiences'] as Array<any>).map(ExperienceWithOriginFromJSON)),
        'dailyRate': NewDailyRateWithOriginFromJSON(json['dailyRate']),
        'workConditions': json['workConditions'] == null ? undefined : WorkConditionsWithOriginFromJSON(json['workConditions']),
        'formerCompanies': json['formerCompanies'] == null ? undefined : ((json['formerCompanies'] as Array<any>).map(FormerCompanyWithOriginFromJSON)),
        'businessSector': json['businessSector'] == null ? undefined : BusinessSectorWithOriginFromJSON(json['businessSector']),
        'keywords': json['keywords'] == null ? undefined : ((json['keywords'] as Array<any>).map(KeywordWithOriginFromJSON)),
        'refinements': json['refinements'] == null ? undefined : ((json['refinements'] as Array<any>).map(RefinementCriteriaWithOriginFromJSON)),
    };
}

export function MatchingCriteriaResponseToJSON(value?: MatchingCriteriaResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jobTitle': JobTitleWithOriginToJSON(value['jobTitle']),
        'category': CategoryWithOriginToJSON(value['category']),
        'initialCategory': CategoryWithOriginToJSON(value['initialCategory']),
        'experiences': ((value['experiences'] as Array<any>).map((v) => ExperienceWithOriginToJSON(v))),
        'dailyRate': NewDailyRateWithOriginToJSON(value['dailyRate']),
        'workConditions': WorkConditionsWithOriginToJSON(value['workConditions']),
        'formerCompanies': value['formerCompanies'] == null ? undefined : ((value['formerCompanies'] as Array<any>).map((v) => FormerCompanyWithOriginToJSON(v))),
        'businessSector': BusinessSectorWithOriginToJSON(value['businessSector']),
        'keywords': value['keywords'] == null ? undefined : ((value['keywords'] as Array<any>).map((v) => KeywordWithOriginToJSON(v))),
        'refinements': value['refinements'] == null ? undefined : ((value['refinements'] as Array<any>).map((v) => RefinementCriteriaWithOriginToJSON(v))),
    };
}

